import React, { useState, useRef } from 'react'
import Api from '../../../_helpers/Api'
import { trans, fromInfo } from '../../../_providers/Translation'
import Results from './partials/BonusPolicyResult'
import Periods from './partials/BonusPolicyPeriods'
import Question from '../../modals/messages/Question'
import Help from '../../partials/Help'
import BonusPolicyTypesTab from './BonusPolicyTypesTab'
import BonusPoliciesDashboard from './BonusPoliciesDashboard'

import BonusPolicy from './partials/BonusPolicy'
import { Tab, Tabs } from '@mui/material'

const TABS_LABELS = [
    { id: 'dashboard', name: trans('tabs.dashboard') },
    { id: 'types', name: trans('nav.bonuspolicies') },
]

function BonusPolicies() {
    const modalRef = useRef(null)
    const periodsModalRef = useRef(null)
    const resultsModalRef = useRef(null)
    const deleteModalRef = useRef(null)


    const [activeTab, setActiveTab] = useState('dashboard')
    const [state, setState] = useState({
        update: false,
    })

    const handleAdd = () => {
        let modal = modalRef.current

        modal.open()
        modal.onSave(data => {
            handleUpdate()
        })
    }

    const handleEdit = id => {
        let modal = modalRef.current

        modal.edit(id)

        modal.onSave(data => {
            handleUpdate()
        })

    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const handleDelete = id => {
        let modal = deleteModalRef.current

        modal.open()

        modal.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handleDestroy = id => {
        Api.post('partners/bonuspolicies/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleUpdate()
            }
        })
    }

    const handleShowPeriods = id => {
        periodsModalRef.current.open(id)
    }

    const handleShowResult = (id, periodId) => {
        let modal = resultsModalRef.current

        modal.open(id, periodId)

        modal.onClose(() => {
            handleShowPeriods(id)
        })
    }

    return (
        <>
            <Question
                ref={deleteModalRef}
                mainMessage={trans('questions.delete')}
            />
            <BonusPolicy ref={modalRef} />
            <Periods ref={periodsModalRef} handleShowResult={handleShowResult} />
            <Results ref={resultsModalRef} />
            <div className="wrapper">
                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.bonusPolicies')} <Help>{fromInfo('bonus')}</Help>
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.bonusPolicies')}
                        </p>
                    </div>
                    <div className="right">
                        <button className="button button-add" onClick={handleAdd}>
                            {trans('buttons.add')}
                        </button>
                    </div>
                </div>
                <Tabs
                    value={activeTab}
                    onChange={(e, id) => setActiveTab(id)}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    {TABS_LABELS.map(t =>
                        <Tab key={t.id} value={t.id} label={t.name} />
                    )}
                </Tabs>
                <div className='pannel'>
                    {activeTab === 'dashboard' && (
                        <BonusPoliciesDashboard update={state.update} />
                    )}
                    {activeTab === 'types' && (

                        <BonusPolicyTypesTab
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            handleShowPeriods={handleShowPeriods}
                            update={state.update}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default BonusPolicies